module.exports = __webpack_public_path__ + "static/media/header-2-background.5dc4c728.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/header-2-background.png
// module id = 324
// module chunks = 0